/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/not-found/app.not-found.component.ts.
 */
import {Component} from '@angular/core';
import {AppConfigService} from '../../services/app.config.service';

/**
 * Zweck: Beschreibt class AppNotFoundComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    // moduleId: module.id,
    selector: 'app-not-found',
    templateUrl: 'app.not-found.component.html',
    styleUrls: ['app.not-found.component.scss'],
    standalone: false
})
export class AppNotFoundComponent {
  static id = 'AppNotFoundComponent';

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public cfg: AppConfigService) {
  }
}
